const userContainPermission = (permission: string, permissions: string[] | null): boolean => {
  if (permissions === null) {
    return false;
  }
  return permissions.includes(permission);
};

export { userContainPermission };
